// extracted by css-extract-rspack-plugin
export default {"ruleSearch":"WrrgqyZEG9EHhIR0","columnContainer":"sPfuyjKDM1MWB2U2"};